import { BarChart } from "./BarChart";
import { HeatmapChart } from "./HeatmapChart";
import { LineChart } from "./LineChart";
import { MixedChart } from "./MixedChart";
import { PieChart } from "./PieChart";
import type {
  ChartInteraction,
  ChartMask,
  ChartSpec,
  ChartVariant,
} from "./types";

interface ChartProps extends ChartInteraction {
  spec: ChartSpec;
  variant?: ChartVariant;
  /** Blur restricted PII / money text (see {@link ChartMask}). */
  mask?: ChartMask;
}

/**
 * Single entry point for the chart kit: dispatch a validated `ChartSpec` to the
 * matching renderer. Surfaces (Kai, dashboard, reports) import only this plus
 * `ChartFrame` / `MetricCard` / `Sparkline` — never the individual charts or D3.
 */
export function Chart({
  spec,
  variant = "default",
  mask,
  onCategoryClick,
  onSeriesClick,
  onCellClick,
  selectedCategory,
  selectedSeriesKey,
  replayNonce,
}: ChartProps) {
  const interaction = {
    onCategoryClick,
    onSeriesClick,
    onCellClick,
    selectedCategory,
    selectedSeriesKey,
    replayNonce,
  };
  switch (spec.type) {
    case "bar":
      return <BarChart spec={spec} variant={variant} mask={mask} {...interaction} />;
    case "line":
      return <LineChart spec={spec} variant={variant} mask={mask} {...interaction} />;
    case "mixed":
      return <MixedChart spec={spec} variant={variant} mask={mask} {...interaction} />;
    case "pie":
      return <PieChart spec={spec} variant={variant} mask={mask} {...interaction} />;
    case "heatmap":
      return <HeatmapChart spec={spec} variant={variant} mask={mask} {...interaction} />;
    default:
      return null;
  }
}
